import {Opening} from "../../../../api/Openings";
import {DialogContent, DialogTitle, Grid} from "@mui/material";
import {Dialog2} from "../../../../misc/Dialog2";
import {SmoothActionBar} from "../../../../misc/SmoothActionBar";
import {useAsyncAction} from "nate-react-api-helpers";
import {useState} from "react";
import {useSyncedRef} from "../../../../misc/SyncedRef";
import {QuoteOpening} from "../../../../api/QuoteOpenings";
import {AutoComplete} from "./AutoComplete";
import {api} from "../../../../api/API";
import {HardwareGroup} from "../../../../api/QuoteHardware";
import {useAlternative} from "../../quote/alternative/Alternative";

export function EditHardwareGroup(props: {
    isQuote: true;
    row: QuoteOpening;
    onCancel(): void;
    onDone(value: QuoteOpening): Promise<any>;
} | {
    isQuote: false;
    row: Opening;
    onCancel(): void;
    onDone(value: Opening): Promise<any>;
}) {
    const doneRef = useSyncedRef(props.onDone);
    const callback = useAsyncAction(input => doneRef.current(input), [doneRef]);

    const [group, setGroup] = useState({
        id: props.row.hardwareGroup as number,
        name: props.row.hardwareGroupName as string,
    });

    const submit = () => callback.callback(Object.assign({}, props.row, {
        hardwareGroup: group.id,
        hardwareGroupName: group.name,
    }));

    return (
        <Dialog2 open={true} onClose={props.onCancel} onEnterPress={submit}>
            <DialogTitle>
                Edit Hardware Heading
            </DialogTitle>
            <DialogContent>
                <div style={{height: 8}} />
                <Grid container spacing={2} flexDirection="column">
                    <Grid item>
                        <HardwareGroupAC label="Group" value={group}
                                         onChange={setGroup} project={props.row.project} isQuote={props.isQuote} />
                    </Grid>
                </Grid>
            </DialogContent>
            <SmoothActionBar
                loading={callback.loading}
                error={callback.error}
                onCancel={props.onCancel}
                onSubmit={submit}
            />
        </Dialog2>
    )
}

function HardwareGroupAC(props: {
    label: string;
    value: any;
    project: number;
    isQuote: boolean;
    onChange(value: HardwareGroup): void;
}) {
    const alternative = useAlternative();

    return (
        <AutoComplete<HardwareGroup>
            label={props.label}
            value={props.value}
            onSelect={props.onChange}
            equals={(a, b) => a.id === b.id}
            makeLabel={a => a.name}
            search={async search => {
                const before = search === "" ? [{name: "(none)", id: null} as any] : [];

                if(props.isQuote) {
                    const rs = await api.quoteHardware.list({
                        project: props.project,
                        alternative: alternative,
                        search: search
                    })
                    return [...before, ...rs.data];
                }

                const rs = await api.hardware.list({project: props.project, search: search})
                return [...before, ...rs.data];
            }}
            fullWidth
        />
    )
}